import { Schema, NodeSpec } from 'prosemirror-model'
import { addListNodes } from 'prosemirror-schema-list'
import OrderedMap from 'orderedmap'

const nodes = {
  doc: {
    content: 'ordered_list+',
  } as NodeSpec,

  text: {
    group: 'inline',
  } as NodeSpec,

  paragraph: {
    content: 'inline*',
    group: 'block',
    parseDOM: [{ tag: 'p' }],
    toDOM() {
      return ['p', 0]
    },
  } as NodeSpec,

  ordered_list: {
    content: 'list_item+',
    group: 'block',
    attrs: { order: { default: 1 } },
    parseDOM: [
      {
        tag: 'ol',
        getAttrs(dom: Node) {
          return {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            order: (dom as HTMLElement).hasAttribute('start') ? (dom as HTMLElement).getAttribute('start')! + 1 : 1,
          }
        },
      },
    ],
    toDOM(node) {
      return node.attrs.order === 1 ? ['ol', 0] : ['ol', { start: node.attrs.order }, 0]
    },
  } as NodeSpec,

  bullet_list: {
    content: 'list_item+',
    group: 'block',
    parseDOM: [{ tag: 'ul' }],
    toDOM() {
      return ['ul', 0]
    },
  } as NodeSpec,

  list_item: {
    content: 'paragraph block*',
    parseDOM: [{ tag: 'li' }],
    toDOM() {
      return ['li', 0]
    },
    defining: true,
  } as NodeSpec,
}

const marks = {}

const _schema = new Schema({ nodes, marks })
export const schema = new Schema({
  nodes: addListNodes(_schema.spec.nodes as OrderedMap<NodeSpec>, 'paragraph block*', 'block'),
  marks,
})
